// extracted by mini-css-extract-plugin
export const container = "series-carousel-module--container--3zP0k";